<template>
  <div class="app-connected-user">
    <el-avatar @click.native="openLogOutConfirmation"
               size="medium">
      <span v-if="isLoading">...</span>
      <span v-else>{{ initials }}</span>
    </el-avatar>
  </div>
</template>

<script>
import i18n from '@/i18n'
import authentificationService from '@/services/authentificationService'

export default {
  name: 'AppConnectedUser',
  data () {
    return {
      isLoading: false,
      connectedUser: null,
    }
  },
  computed: {
    initials () {
      return this.connectedUser.given_name.charAt(0) + this.connectedUser.family_name.charAt(0)
    },
  },
  created () {
    this.getConnectedUser()
  },
  methods: {
    getConnectedUser () {
      this.isLoading = true

      authentificationService
        .getConnectedUser()
        .then(connectedUser => this.connectedUser = connectedUser)
        .catch(error => {
          console.error(error)
          this.$message.error(i18n.t('CONNECTED_USER.ERRORS.GET'))
        })
        .finally(() => this.isLoading = false)
    },
    openLogOutConfirmation () {
      this.$confirm(
        '',
        this.connectedUser.name,
        {
          confirmButtonText: i18n.t('ACTIONS.LOG_OUT'),
          cancelButtonText: i18n.t('ACTIONS.CANCEL'),
          customClass: 'alert-fit-mobile',
          roundButton: true,
        })
        .then(() => authentificationService.logOut())
        .then(() => document.location.reload())
        .catch(error => {
          if (error !== 'cancel') {
            console.error(error)
            this.$message.error(i18n.t('CONNECTED_USER.ERRORS.LOG_OUT'))
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.app-connected-user {
  .el-avatar {
    cursor: pointer;
    user-select: none;
  }
}
</style>
